import { useFormikContext } from "formik"
import React from "react"
import useHideAndShowField from "./hooks/useHideAndShowField"


const TextDevider = ({
  inputGroupClassName = "form-group",
  field, // { name, value, onChange, onBlur }
  size = 12,
  label="",
  className="text-start",
  ...props
}) => {
  const formik = useFormikContext()
  const conditionalShowAndHideClassName = useHideAndShowField({ formik, fieldName: field.name, ...props })
  return (
    <div className={ inputGroupClassName  + conditionalShowAndHideClassName + ` col-lg-${size} `}style={{ margin: 0 }}
>
      {label && <label className={className} >{label}</label>}
    </div>
  )
}

export default TextDevider
